// extracted by mini-css-extract-plugin
export var container = "_56-0";
export var fallback = "_56-5";
export var fallbackIcon = "_56-6";
export var hidden = "_56-2";
export var image = "_56-3";
export var loaded = "_56-4";
export var placeholder = "_56-1";